import { Button, Divider, Modal, Typography } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import * as XLSX from "xlsx";
import { setUploadCandidate } from "redux/slices/candidateSlice";
import DragUpload from "../../../../../../common/components/uploadComponent/dragger";
import K from "../../../../../../utilities/constants";
import LocalFile from "../../../../../../assets/Source2_Candidate_upload_Rich_File_LOCAL.xlsx";
import QAFile from "../../../../../../assets/Source2_Candidate_upload_Rich_File_QA.xlsx";
import StagingFile from "../../../../../../assets/Source2_Candidate_upload_Rich_File_STAGING.xlsx";
import DefaultFile from "../../../../../../assets/Source2_Candidate_upload_Rich_File.xlsx";

const { DEVELOPMENT, QA, STAGING } = K.Environment;

const SAMPLE_FILES = {
  [DEVELOPMENT]: LocalFile,
  [QA]: QAFile,
  [STAGING]: StagingFile,
};

const SampleCSV = SAMPLE_FILES[K.Server] || DefaultFile;

export const UploadCsvButton = ({ clientId, disabled }) => {
  const [open, setOpen] = useState(false);
  const [csvFile, setCSVFile] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();

  const onCancel = () => {
    setCSVFile(null);
    setOpen(false);
  };

  const onFileChange = (file) => {
    if (!file) {
      setCSVFile(null);
      return;
    }

    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws, {
        raw: false,
        defval: "",
        blankrows: false,
      });
      const updatedData = [];
      data.forEach((item, index) => {
        if (item["First Name"] !== "") {
          const type =
            K.UploadHireType.find((i) => i.label === item["Candidate Type"])
              ?.value ??
            item["Candidate Type"] ??
            "";

          const updatedItem = {
            ...item,
            id: index,
            "Candidate Type": type,
          };
          updatedData.push(updatedItem);
        }
      });

      dispatch(setUploadCandidate(updatedData));
      setCSVFile({});
      history.push(`/candidates/preview-upload`);
    };
    reader.readAsBinaryString(file);
  };

  return (
    <>
      <Button type="primary" disabled={disabled} onClick={() => setOpen(true)}>
        Upload CSV File
      </Button>

      <Modal
        title="Upload CSV File"
        centered
        className="s2-theme-style"
        onCancel={onCancel}
        okButtonProps={{
          disabled: !csvFile,
        }}
        destroyOnClose
        open={open}
      >
        <DragUpload
          onFileChange={onFileChange}
          allowedTypes={[K.FileUpload.Types.XLSX]}
          maxSize={1024 * 1024 * 5}
        />
        <div className="d-flex mt-3 justify-content-center">
          <Typography.Link
            href={SampleCSV}
            download="Source2_Candidate_upload_Rich_File.xlsx"
          >
            Click here to download sample excel file
          </Typography.Link>
        </div>
        <Divider />
      </Modal>
    </>
  );
};
